import {
    TextHelper,
    //SmallTextHelper,
    UrlHelper,
    //ArrayHelper
} from '../../PrismicHelpers';

export const testimonialsSliceArray = (data) => {
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = data.slice_type;
    // Non repetable data inside slice
    //const sliceFixedData = data.primary;
    // Repetable data (example: buttons)
    const sliceRepetableData = data.items;
    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        testimonials: !(sliceRepetableData && sliceRepetableData.length > 0) ? null : sliceRepetableData.map(element => {
            if (element.testimonial_single && element.testimonial_single.id) return element.testimonial_single.id
        })
    };

    if(!dataToSend.testimonials) return null;
    
    return dataToSend
}

export const testimonialsSliceRelationship = (data, sliceType) => {
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = sliceType;
    // Non repetable data inside slice
    //const sliceFixedData = data.primary;
    // Repetable data (example: buttons)
    const sliceRepetableData = data.results;
    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        testimonials: !(sliceRepetableData && sliceRepetableData.length > 0) ? null : sliceRepetableData.map(element => {
            return {
                name: TextHelper(element.data.name),
                description: TextHelper(element.data.description),
                company: TextHelper(element.data.company),
                image_alternative: TextHelper(element.data.image_alternative),
                image: UrlHelper(element.data.image),
            }
        })
    };
    return dataToSend
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-slice-helpers/single-slice-helpers/testimonialsSlice.js